import { type ReactNode } from "react";

import { CloseButton } from "@vega-core/components/Buttons/CloseButton/CloseButton";

type Props = {
  title: string;
  onClose: VoidFunction;
  headerAction?: ReactNode;
};

export const SidebarModalHeader = ({ title, onClose, headerAction }: Props) => (
  <div className="flex items-center justify-between gap-4 p-6 border-b-1 border-border/primary">
    <h3 className="heading-4 py-1.5">{title}</h3>

    <div className="flex items-center gap-2">
      {headerAction}
      <CloseButton onClick={onClose} />
    </div>
  </div>
);
